module.exports = __webpack_public_path__ + "img/card.d91c027e.png";